import React from 'react';
import { Box, Button, Divider, IconButton, Paper, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

interface EditableConditionsListProps {
  conditions: string[];
  title?: string;
  showHeader?: boolean;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, value: string) => void;
}

export const EditableConditionsList: React.FC<EditableConditionsListProps> = ({
  conditions,
  title = 'Conditions & Stipulations',
  showHeader = true,
  onAdd,
  onRemove,
  onChange,
}) => {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
      {showHeader && (
        <Box sx={{ px: 2, py: 1.5, bgcolor: 'grey.50', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={{ p: 2 }}>
        {conditions.map((condition, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
              mb: 1.5,
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 24, pt: 1, fontWeight: 600 }}>
              {index + 1}.
            </Typography>
            <TextField
              size="small"
              fullWidth
              multiline
              value={condition}
              onChange={e => onChange(index, e.target.value)}
              placeholder="Enter Condition"
              variant="outlined"
            />
            <IconButton
              size="small"
              onClick={() => onRemove(index)}
              sx={{ mt: 0.5, color: 'text.disabled', '&:hover': { color: 'error.main' } }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}

        {/* Empty slot for next entry */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 24, fontWeight: 600 }}>
            {conditions.length + 1}.
          </Typography>
          <TextField
            size="small"
            fullWidth
            placeholder="Enter Condition"
            variant="outlined"
            disabled
            sx={{ opacity: 0.5 }}
          />
        </Box>

        <Divider sx={{ my: 1 }} />
        <Button
          startIcon={<AddIcon />}
          size="small"
          onClick={onAdd}
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        >
          Add Condition
        </Button>
      </Box>
    </Paper>
  );
};
